import React from "react";

import HeroSection from "../../components/HowItWorks/HeroSection/HeroSection";
import PhilosophySection from "../../components/HowItWorks/PhilosophySection/PhilosophySection";
import WorkflowSection from "../../components/HowItWorks/WorkflowSection/WorkflowSection";
import FeaturesSection from "../../components/HowItWorks/FeaturesSection/FeaturesSection";
import CallToActionSection from "../../components/HowItWorks/CallToActionSection/CallToActionSection";
import "./HowItWorksPage.css";

import PhilosophyTimelineSection from "../../components/HowItWorks/PhilosophySection/PhilosophySection";

export default function HowItWorksPage() {
  return (
    <div className="how-it-works-page-wrapper">
      <HeroSection />
      <PhilosophyTimelineSection />
      <WorkflowSection />
      <FeaturesSection />
      <CallToActionSection />
    </div>
  );
}
